class MarketsService {
    validator(condition, market) {
        let status = false;

        if (!condition) return true;

        if (!condition.LogicType) {
            Object.keys(condition).map((key) => {
                let val = condition[key];

                if (val === 'empty') {
                    if (!market[key]) {
                        status = true;
                        return false;
                    }
                } else {
                    if (typeof val === 'object') {
                        if (val.not) {
                            if (market[key] !== val.not) {
                                status = true;
                                return false;
                            }
                        }

                        if (val.notArray) {
                            if (val.notArray.indexOf(market[key]) === -1) {
                                status = true;
                                return false;
                            }
                        }

                        if (val.inArray) {
                            if (val.inArray.indexOf(market[key]) > -1) {
                                status = true;
                                return false;
                            }
                        }

                        if (val.notContain) {
                            status = true;

                            for (let i = 0; i < val.notContain.length; i++) {
                                if (
                                    market[key] &&
                                    '' +
                                        market[key].indexOf(val.notContain[i]) >
                                        -1
                                ) {
                                    status = false;
                                    return false;
                                }
                            }
                        }

                        if (val.contain) {
                            status = false;

                            for (let i = 0; i < val.contain.length; i++) {
                                if (
                                    market[key] &&
                                    '' + market[key].indexOf(val.contain[i]) >
                                        -1
                                ) {
                                    status = true;
                                    return true;
                                }
                            }
                        }
                    } else {
                        if (market[key] === val) {
                            status = true;
                            return false;
                        }
                    }
                }

                return key;
            });
        } else {
            if (condition.LogicType === 'OR') {
                Object.keys(condition).map((key) => {
                    let val = condition[key];

                    if (key !== 'LogicType') {
                        if (val === 'empty') {
                            if (!market[key]) {
                                status = true;
                                return false;
                            }
                        } else {
                            if (typeof val === 'object') {
                                if (val.not) {
                                    if (market[key] !== val.not) {
                                        status = true;
                                        return false;
                                    }
                                }

                                if (val.notArray) {
                                    // val.notArray.map((str) => {
                                    //     str = "" + str;
                                    //
                                    //     if (market[key] && ("" + market[key]).indexOf(str) > -1) {
                                    //       status = true;
                                    //       return false;
                                    //     }
                                    //
                                    //     return str;
                                    // });
                                    if (
                                        val.notArray.indexOf(market[key]) === -1
                                    ) {
                                        status = true;
                                        return false;
                                    }
                                }

                                if (val.inArray) {
                                    if (val.inArray.indexOf(market[key]) > -1) {
                                        status = true;
                                        return false;
                                    }
                                }

                                if (val.contain) {
                                    for (
                                        let i = 0;
                                        i < val.contain.length;
                                        i++
                                    ) {
                                        if (
                                            market[key] &&
                                            '' +
                                                market[key].indexOf(
                                                    val.contain[i]
                                                ) >
                                                -1
                                        ) {
                                            status = true;
                                            return false;
                                        }
                                    }
                                }
                            } else {
                                if (market[key] === val) {
                                    status = true;
                                    return false;
                                }
                            }
                        }
                    }

                    return key;
                });
            } else {
                status = true;

                Object.keys(condition).map((key) => {
                    let val = condition[key];

                    if (key !== 'LogicType') {
                        if (val === 'empty') {
                            if (market[key]) {
                                status = false;
                                return false;
                            }
                        } else {
                            if (typeof val === 'object') {
                                if (val.not) {
                                    if (market[key] === val.not) {
                                        status = false;
                                        return false;
                                    }
                                }
                                if (val.notArray) {
                                    // val.notArray.map((str) => {
                                    //     str = "" + str;
                                    //
                                    //     if (market[key] && ("" + market[key]).indexOf(str) > -1) {
                                    //         status = false;
                                    //         return false;
                                    //     }
                                    //
                                    //     return str;
                                    // });

                                    if (
                                        val.notArray.indexOf(market[key]) === -1
                                    ) {
                                        status = true;
                                        return false;
                                    }
                                }
                                if (val.inArray) {
                                    if (val.inArray.indexOf(market[key]) < 0) {
                                        status = false;
                                        return false;
                                    }
                                }
                            } else {
                                if (market[key] !== val) {
                                    status = false;
                                    return false;
                                }
                            }
                        }
                    }

                    return key;
                });
            }
        }

        return status;
    }
}

export default new MarketsService();
